function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6BE94"
    },
    points: "487.781,484 23.781,484 23.781,268 119.782,268 255.781,132 391.784,268 487.781,268  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 207.781,
    y: 388,
    style: {
      fill: "#996459"
    },
    width: 96,
    height: 96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BB9EC"
    },
    d: "M301.781,356h-92c-1.105,0-2,0.895-2,2v30h96v-30C303.781,356.895,302.886,356,301.781,356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F19"
    },
    d: "M329.617,68l13.039-19.562c1.633-2.453,1.789-5.609,0.398-8.211S338.953,36,336,36h-80 c-4.422,0-8,3.578-8,8v48c0,4.422,3.578,8,8,8h80c2.953,0,5.664-1.625,7.055-4.227s1.234-5.758-0.398-8.211L329.617,68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M256,140c-4.422,0-8-3.578-8-8V28c0-4.422,3.578-8,8-8s8,3.578,8,8v104 C264,136.422,260.422,140,256,140z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F19"
    },
    d: "M288.391,168.938c1.234-2.992,4.156-4.938,7.391-4.938h152c2.734,0,5.281,1.398,6.75,3.703l56,88 c1.57,2.469,1.664,5.586,0.266,8.148c-1.406,2.555-4.094,4.148-7.016,4.148h-120c-2.125,0-4.156-0.844-5.656-2.344l-88-88 C287.836,175.367,287.148,171.93,288.391,168.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F19"
    },
    d: "M223.391,168.938C222.156,165.945,219.234,164,216,164H64c-2.734,0-5.281,1.398-6.75,3.703l-56,88 c-1.57,2.469-1.664,5.586-0.266,8.148C2.391,266.406,5.078,268,8,268h120c2.125,0,4.156-0.844,5.656-2.344l88-88 C223.945,175.367,224.633,171.93,223.391,168.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3001E"
    },
    d: "M391.891,275.891c-2.047,0-4.094-0.781-5.656-2.344L256,143.313L125.766,273.547 c-3.125,3.125-8.188,3.125-11.313,0s-3.125-8.188,0-11.313l135.891-135.891c3.125-3.125,8.188-3.125,11.313,0l135.891,135.891 c3.125,3.125,3.125,8.188,0,11.313C395.984,275.109,393.938,275.891,391.891,275.891z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFEBB7"
    },
    cx: 256.001,
    cy: 268,
    r: 48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M256,236c-4.422,0-8,3.578-8,8v16h-16c-4.422,0-8,3.578-8,8s3.578,8,8,8h24c4.422,0,8-3.578,8-8 v-24C264,239.578,260.422,236,256,236z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BB9EC"
    },
    d: "M375.781,320c0-11.046-8.954-20-20-20s-20,8.954-20,20c0,1.37,0.141,2.707,0.403,4h-0.403v32h40 v-32h-0.403C375.641,322.707,375.781,321.37,375.781,320z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M356,292c-15.438,0-28,12.562-28,28v36c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-36 C384,304.562,371.438,292,356,292z M356,308c6.617,0,12,5.383,12,12v4h-24v-4C344,313.383,349.383,308,356,308z M344,348v-8h24v8 H344z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.001,
    y: 396,
    style: {
      fill: "#4BB9EC"
    },
    width: 40,
    height: 48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M176,388h-40c-4.422,0-8,3.578-8,8v48c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-48 C184,391.578,180.422,388,176,388z M168,404v8h-24v-8H168z M144,436v-8h24v8H144z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.782,
    y: 396,
    style: {
      fill: "#4BB9EC"
    },
    width: 40,
    height: 48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M103.781,388h-40c-4.422,0-8,3.578-8,8v48c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-48 C111.781,391.578,108.203,388,103.781,388z M95.781,404v8h-24v-8H95.781z M71.781,436v-8h24v8H71.781z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 396,
    style: {
      fill: "#4BB9EC"
    },
    width: 40,
    height: 48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M448,388h-40c-4.422,0-8,3.578-8,8v48c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-48 C456,391.578,452.422,388,448,388z M440,404v8h-24v-8H440z M416,436v-8h24v8H416z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.782,
    y: 396,
    style: {
      fill: "#4BB9EC"
    },
    width: 40,
    height: 48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M375.781,388h-40c-4.422,0-8,3.578-8,8v48c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-48 C383.781,391.578,380.203,388,375.781,388z M367.781,404v8h-24v-8H367.781z M343.781,436v-8h24v8H343.781z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BB9EC"
    },
    d: "M447.563,320c0-11.046-8.954-20-20-20s-20,8.954-20,20c0,1.37,0.141,2.707,0.403,4h-0.403v32h40 v-32h-0.403C447.422,322.707,447.563,321.37,447.563,320z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M427.781,292c-15.438,0-28,12.562-28,28v36c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-36 C455.781,304.562,443.219,292,427.781,292z M427.781,308c6.617,0,12,5.383,12,12v4h-24v-4 C415.781,313.383,421.164,308,427.781,308z M415.781,348v-8h24v8H415.781z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BB9EC"
    },
    d: "M103.563,320c0-11.046-8.954-20-20-20s-20,8.954-20,20c0,1.37,0.141,2.707,0.403,4h-0.403v32h40 v-32h-0.403C103.422,322.707,103.563,321.37,103.563,320z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M83.781,292c-15.438,0-28,12.562-28,28v36c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-36 C111.781,304.562,99.219,292,83.781,292z M83.781,308c6.617,0,12,5.383,12,12v4h-24v-4C71.781,313.383,77.164,308,83.781,308z  M71.781,348v-8h24v8H71.781z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BB9EC"
    },
    d: "M175.344,320c0-11.046-8.954-20-20-20s-20,8.954-20,20c0,1.37,0.141,2.707,0.403,4h-0.403v32h40 v-32h-0.403C175.203,322.707,175.344,321.37,175.344,320z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M155.563,292c-15.438,0-28,12.562-28,28v36c0,4.422,3.578,8,8,8h40c4.422,0,8-3.578,8-8v-36 C183.563,304.562,171,292,155.563,292z M155.563,308c6.617,0,12,5.383,12,12v4h-24v-4C143.563,313.383,148.945,308,155.563,308z  M143.563,348v-8h24v8H143.563z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M256,324c-30.879,0-56-25.121-56-56s25.121-56,56-56s56,25.121,56,56S286.879,324,256,324z  M256,228c-22.055,0-40,17.943-40,40s17.945,40,40,40s40-17.943,40-40S278.055,228,256,228z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M288,348h-64c-13.234,0-24,10.766-24,24v112c0,4.422,3.578,8,8,8s8-3.578,8-8v-88h31.781v88h16v-88 H296v88c0,4.422,3.578,8,8,8s8-3.578,8-8V372C312,358.766,301.234,348,288,348z M296,380h-80v-8c0-4.414,3.586-8,8-8h64 c4.414,0,8,3.586,8,8V380z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M504,492H8c-4.422,0-8-3.578-8-8s3.578-8,8-8h496c4.422,0,8,3.578,8,8S508.422,492,504,492z"
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.5eef058d.svg";
export { ForwardRef as ReactComponent };